import { SectionEyebrow } from '#app/shared/ui/data-display/SectionEyebrow.tsx'
import { Icon } from '#app/shared/ui/icons/Icon.tsx'
import { type IconName } from '#app/shared/ui/icons/name.ts'
import { MainContainer } from '#app/shared/ui/layout/MainContainer.tsx'

const SERVICES: {
  icon: IconName
  title: string
  description: string
}[] = [
  {
    icon: 'basic/shield-check',
    title: 'Garantía incluida',
    description: '1 año de garantía incluida, ampliable hasta 3 años.',
  },
  {
    icon: 'basic/shield-dollar',
    title: 'Financiación flexible',
    description: 'Opciones adaptadas a cada cliente.',
  },
  {
    icon: 'basic/car',
    title: 'Tasamos tu coche',
    description: 'Recibimos tu coche como parte del pago.',
  },
  {
    icon: 'basic/booked',
    title: 'Entrega inmediata',
    description: 'Recógelo gratis o lo enviamos a tu domicilio.',
  },
  {
    icon: 'basic/file-shield',
    title: 'Coches a la carta',
    description: 'Buscamos en Europa el coche ideal para ti.',
  },
]

export const Services = () => {
  return (
    <MainContainer
      className={`
        px-4 pb-16

        lg:pb-20

        sm:px-6
      `}
    >
      <SectionEyebrow className="mb-6">Servicios a tu medida</SectionEyebrow>
      <div
        className={`
          overflow-hidden rounded-lg border border-neutral-75 bg-white

          lg:grid-cols-5

          sm:grid sm:grid-cols-2 sm:gap-4 sm:overflow-visible sm:rounded-none
          sm:border-0 sm:bg-transparent

          xl:gap-5
        `}
      >
        {SERVICES.map((service) => (
          <div
            key={service.title}
            className={`
              flex items-start gap-4 border-b border-neutral-75 p-4
              text-base-medium

              last:border-b-0

              sm:flex-col sm:gap-0 sm:rounded-lg sm:border sm:border-neutral-75
              sm:bg-white sm:p-5 sm:last:border-b
            `}
          >
            <div
              className={`
                flex h-10 w-10 shrink-0 items-center justify-center rounded-full
                bg-primary-50

                sm:mb-5
              `}
            >
              <Icon name={service.icon} size="20px" className="text-primary" />
            </div>
            <div>
              <p className="mb-2 font-bold text-primary-800">{service.title}</p>
              <p className="text-neutral-600">{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </MainContainer>
  )
}
